import { useSelector } from "../configureStore";

export const useHighlightRequiredFields = () => {
  const highlightRequiredFields = useSelector<boolean>(
    (state) => state.form.highlightRequiredFields
  );

  return highlightRequiredFields;
};
